import { Injectable, inject } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { StorageService } from './storage.service';

export interface GalleryDisplayPreferences {
  sorting: string;
  appearance: string;
  pinFavourites: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class GalleryDisplayPreferencesService {
  private storage = inject(StorageService);
  public displayPreferences$ = new BehaviorSubject<GalleryDisplayPreferences>(this.getPreferences());

  updatePreferences(preferences: GalleryDisplayPreferences) {
    this.storage.set('galleries-preferences', preferences);
    this.displayPreferences$.next(preferences);
  }

  private getPreferences(): GalleryDisplayPreferences {
    const value = this.storage.get<GalleryDisplayPreferences>('galleries-preferences') || <GalleryDisplayPreferences>{};
    return {
      sorting: value.sorting || '-last_changed_at',
      appearance: value.appearance || 'default',
      pinFavourites: value.pinFavourites || false,
    };
  }
}
